import {NORMALIZATION_STATE_BASE_PROPERTIES} from './cardStateEnum';

// --This enum file is for stateContent creation to support SW v.1.27 and older-- //

// eslint-disable-next-line import/prefer-default-export
export const OLD_NORMALIZATION_STATE_TASK_PROPERTIES = [
  ...NORMALIZATION_STATE_BASE_PROPERTIES,
  'selectedLabware',
  'selectedDiluentWell',
];
